import moment from 'moment';
import { systemProperties } from 'systemProperties';

const formatDate = (date: string, format = systemProperties.dateFormat) => {
	if(!date) return;
	return moment(date).format(format);
};

export default formatDate;